import { useCallback, useContext, useEffect, useState } from 'react';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';

import { StepThreeFormContext } from '../../../../../StepThree/contexts/StepThreeForm';

import './index.css';
import { getExplanatoryTexts } from '../../../../../../../utils';
import { MasterContext } from '../../../../../../../../../../../shared/contexts';
import { QuotationInfoContext } from '../../../../../../../shared';
import { Typography } from 'antd';
import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface PlansSectionProps {
  duplicateId?: number;
  id: number;
}

export const PlansSection = ({ duplicateId, id }: PlansSectionProps) => {
  const { setCanGetCoveragesPerPlanByTab } = useContext(StepThreeFormContext);
  const {
    stepTwoForm,
    planOptionsBySelectedPlan,
    getOptionsTypesHousing,
  } = useContext(StepTwoFormContext);

  const validateForm = new ValidateForm();

  const handleDuplicateFields = () => {
    if (duplicateId) {
      const duplicatePlan = stepTwoForm?.getFieldValue(
        `plan-tab-${duplicateId}`
      );
      stepTwoForm?.setFieldValue(`plan-tab-${id}`, duplicatePlan);
    }
  };

  const { globalPublicConfigs } = useContext(MasterContext);
  const { quotationInfo } = useContext(QuotationInfoContext);
  const [explanatoryText, setExplanatoryText] = useState<string>("");    
  const handleExplanatoryText = () => {
        const text = getExplanatoryTexts(
            Number(quotationInfo?.branch),
            Number(quotationInfo?.article), 
            Number(stepTwoForm?.getFieldValue(`plan-tab-${id}`)),
          globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
        );
        setExplanatoryText(text);
        stepTwoForm?.setFieldValue(`explanatory-text-tab-${id}`, text);
    }; 

  const onSelectPlan = useCallback(async () => {
    const planFormItemName = `plan-tab-${id}`;
    const planSelected = stepTwoForm?.getFieldValue(planFormItemName);
    const fieldNames = stepTwoForm?.getFieldsValue();    

    const fieldsToReset = Object.keys(fieldNames).filter((fieldName) =>
      fieldName.startsWith(`feature-tab-${id}-`)
    );

    stepTwoForm?.resetFields(fieldsToReset);
    stepTwoForm?.resetFields([`type-housing-tab-${id}`]);

    await getOptionsTypesHousing(planSelected);
    setCanGetCoveragesPerPlanByTab((prev: any) => ({
      ...prev,
      [id]: true,
    }));
  }, [
    id,
    stepTwoForm,
    getOptionsTypesHousing,
    setCanGetCoveragesPerPlanByTab,
  ]);

  useEffect(() => {
    handleExplanatoryText();
    handleDuplicateFields();
  }, []);

  return (
    <ContentSection level='h3' title='Planes'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Lista de Planes',
              name: `plan-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'lista de planes',
                rules: ['required'],
              }),
            }}
            selectProps={{
              options: planOptionsBySelectedPlan,
              onSelect: onSelectPlan,
              onChange: handleExplanatoryText,
            }}
          />
        </ColSize>
      </RowSize>

      {!!explanatoryText && 
            <Typography.Text strong style={{ fontSize: 16, color: COLORS.neutrals[70] }} >
              {explanatoryText}
            </Typography.Text>
      }
      
    </ContentSection>
  );
};
